import React, { Fragment } from "react";

import { EuiBreadcrumbs, EuiSpacer } from "@elastic/eui";

export default function ManualBreadcrumbs() {
  const breadcrumbs = [
    {
      text: "Overview",
      href: "/en/Indoor_Cameras/IN-8815_QFHD/",
    },
    {
      text: "Specifications",
      href: "/en/Indoor_Cameras/IN-8815_QFHD/Technical_Specifications/",
    },
    {
      text: "Features",
      href: "/en/Indoor_Cameras/IN-8815_QFHD/Product_Features/",
    },
    {
      text: "Installation",
      href: "/en/Indoor_Cameras/IN-8815_QFHD/Quick_Installation/",
    },
    {
      text: "Lense Adjustment",
      href: "/en/Indoor_Cameras/IN-8815_QFHD/Lense_Adjustment/",
    },
    {
      text: "Usermanual",
      href: "/en/Indoor_Cameras/IN-8815_QFHD/Usermanual/",
    },
    {
      text: "◄ Indoor Cameras",
      href: "/en/Indoor_Cameras/",
    },
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-8815 4K UHD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}
